// src/modules/app-views/_apps/appmulti/coupons/pages/Init/components/tableColumns/discountColumn.js
import translateX from 'utils/translateX';

function discountColumn(buildColumnProps, options = {}) {
  const {
    key = 'discount',
    title = 'discount',
    dataIndex = 'discount',
    width = 140,
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    ...(width && { width }),
    ...buildColumnProps(dataIndex, columnProps),
    align: 'right',
    render: (_, r) => {
      if (r?.discount == null) return <span className="text-muted">—</span>;
      return r?.type === 'value' ? (
        <span>R$ {r.discount}</span>
      ) : (
        <span>{r.discount}%</span>
      );
    },
  };
}

export default discountColumn;
